export const truncate = (str: string, len: number): string =>
  str.length > len ? `${str.substring(0, len)}...` : str;

export const isEmpty = (value: string): boolean =>
  value == null || value === '';
